//#region import
import React from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router";
import { I18n } from "utilities/utilities";
import Tabs, { TabContent, TabItem, TabPanel } from "components/Input/Tab";
import { EditNote, PostAdd, RestorePage } from "@mui/icons-material";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import EquipmentListTabel from "./EquipmentListTabel";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
//#endregion

export default function EquipmentList() {
  const location = useLocation();
  const searchParams = location.search;
  const sMode = new URLSearchParams(searchParams).get("sMode");

  return (
    <>
      <Grid container spacing={2}>
        <Grid item marginTop={"10px"} xs={12}>
          <Tabs id={"MaterialInventory"} defaultTab={!sMode ? "Receive" : sMode}>
            <TabItem id="Receive"><AddShoppingCartIcon className="vertical-middle"/>{" "}{"การรับครุภัณฑ์"}</TabItem>
            <TabItem id="Withdraw"><EditNote className="vertical-middle"/>{" "}{"การยืมครุภัณฑ์"}</TabItem>
            <TabItem id="Return"><RestorePage className="vertical-middle"/>{" "}{"การคืนครุภัณฑ์"}</TabItem>
            <TabItem id="Cutoff"><RemoveCircleIcon className="vertical-middle"/>{" "}{"การตัดจำหน่าย"}</TabItem>
            <TabContent id={"MaterialInventoryTabContent"}>
               <TabPanel id="Receive">
                <EquipmentListTabel sMode="Receive" />
              </TabPanel>
              <TabPanel id="Withdraw">
                <EquipmentListTabel sMode="Withdraw" />
              </TabPanel>
              <TabPanel id="Return">
                <EquipmentListTabel sMode="Return" />
              </TabPanel>
              <TabPanel id="Cutoff">
                <EquipmentListTabel sMode="Cutoff" />
              </TabPanel>
            
            </TabContent>
          </Tabs>
        </Grid>
      </Grid>
    </>
  );
}
